<!-- <button class="bck" type="button" (click)="goBack()">
	<mat-icon>keyboard_arrow_left</mat-icon>
	<a class="align-middle">{{ 'app.back' | translate }}</a>
</button> -->

<button mat-button class="back-btn pl-0" (click)="goBack()">
	<mat-icon>keyboard_arrow_left</mat-icon>
	<span>Back</span>
</button>
